import React, { useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";

interface IParams {
  fps?: number;
  size?: number;
  aspectRatio?: number;
  disableFlip?: boolean;
  onReadSuccess: (decodedText: string, decodedResult: any) => void;
}

const Html5QrReader: React.FC<IParams> = ({
  fps,
  size,
  aspectRatio,
  disableFlip,
  onReadSuccess,
}) => {
  const readerId = "readerId";

  const createConfigObject = () => {
    var config: any = {};
    config.fps = fps ? fps : 10;
    if (size) config.qrbox = size;
    config.disableFlip = disableFlip ? disableFlip : false;
    if (aspectRatio) config.aspectRatio = aspectRatio;
    return config;
  };

  useEffect(() => {
    const config = createConfigObject();

    let html5QrcodeScanner = new Html5Qrcode(readerId);
    html5QrcodeScanner.start(
      { facingMode: "environment" },
      config,
      (decodedText: string, decodedResult: any) => {
        onReadSuccess(decodedText, decodedResult);
        html5QrcodeScanner.stop().catch();
      },
      () => {}
    );
    return () => {
      html5QrcodeScanner.stop();
      html5QrcodeScanner.clear();
    };
  }, [readerId]);

  return (
    <>
      <div id={readerId}></div>
    </>
  );
};

export default Html5QrReader;
